import React from 'react';
import { Wrench, Zap, Paintbrush, Hammer, Box, Square, Home, Minus, ArrowRight } from 'lucide-react';
import { services } from '../data/mock';
import { useLanguage } from '../contexts/LanguageContext';

const iconComponents = {
  Wrench,
  Zap,
  Paintbrush,
  Hammer,
  Box,
  Square,
  Home,
  Minus,
};

const Services = () => {
  const { t } = useLanguage();
  
  return (
    <section id="servicios" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            {t('services.badge')}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            {t('services.title')}{' '}
            <span className="bg-gradient-to-r from-blue-600 to-blue-600 text-transparent bg-clip-text">
              {t('services.titleHighlight')}
            </span>
          </h2>
          <p className="text-lg text-slate-600">
            {t('services.subtitle')}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconComponents[service.icon];
            const serviceKey = service.nameEn.toLowerCase().replace(/ /g, '');
            
            return (
              <div
                key={service.id}
                className="group bg-white rounded-2xl p-6 hover:shadow-2xl transition-all duration-300 border border-slate-200 hover:border-blue-400 hover:-translate-y-2 cursor-pointer"
                style={{
                  animationDelay: `${index * 100}ms`,
                }}
              >
                {/* Icon */}
                <div className="relative mb-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-500 rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-transform duration-300">
                    {IconComponent && (
                      <IconComponent className="w-8 h-8 text-white" strokeWidth={2.5} />
                    )}
                  </div>
                  <div className="absolute top-0 left-0 w-16 h-16 bg-blue-500 rounded-xl blur-xl opacity-0 group-hover:opacity-50 transition-opacity duration-300" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-blue-600 transition-colors">
                  {t(`services.${serviceKey}`)}
                </h3>
                <p className="text-slate-600 text-sm leading-relaxed mb-4">
                  {t(`services.${serviceKey}.desc`)}
                </p>

                {/* Learn More Link */}
                <div className="flex items-center gap-2 text-blue-600 font-semibold text-sm group-hover:gap-3 transition-all">
                  <span>{t('services.moreInfo')}</span>
                  <ArrowRight className="w-4 h-4" />
                </div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-slate-600 mb-6 text-lg">
            {t('services.notFound')}
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-slate-900 text-white px-8 py-4 rounded-xl font-bold hover:bg-blue-500 hover:text-slate-900 transition-all duration-300 hover:shadow-xl inline-flex items-center gap-2"
          >
            {t('services.contactMore')}
            <ArrowRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
